import { useState } from 'react';
import { observer } from 'mobx-react';

import FancyPopup from '@/common/components/FancyPopup/FancyPopup';
import PinMenuListItem from '@/common/components/Header/PinNavItem/PinMenuListItem/PinMenuListItem';
import PinNavButton from '@/common/components/Header/PinNavItem/PinNavButton/PinNavButton';
import { MenuProvider } from '@/common/components/MenuList/MenuContext/MenuContext';
import { PinnedProduct } from '@/forwarding/entities/PinnedItem/PinnedProduct';
import { formatCompareTitle, PinnedProductsPair } from '@/forwarding/utils/pinnedProducts';
import { BaseProductType } from '@/product/constants/productTypes';

import MenuList from '../../../MenuList/MenuList';

import styles from './CompareNavButton.module.css';

interface CompareNavButtonProps {
  productTypeAndProductsPairs: PinnedProductsPair[];
  onSelect: (products: PinnedProduct[], productType: BaseProductType) => void;
}

function CompareNavButton(props: CompareNavButtonProps) {
  const { productTypeAndProductsPairs, onSelect } = props;
  const [isOpened, setIsOpen] = useState(false);

  if (productTypeAndProductsPairs.length === 0) {
    return null;
  }

  if (productTypeAndProductsPairs.length === 1) {
    const [productType, products] = productTypeAndProductsPairs[0];

    return (
      <PinNavButton
        icon="compare"
        aria-label="Compare pinned products"
        onClick={() => onSelect(products, productType)}
      />
    );
  }

  return (
    <MenuProvider onClick={() => setIsOpen(false)}>
      <FancyPopup
        isOpen={isOpened}
        onChangeState={setIsOpen}
        onClickOutside={() => setIsOpen(false)}
        className={styles.comparePopup}
        action="click"
        trigger={<PinNavButton icon="compare" aria-label="Compare pinned products" />}
        body={(
          <MenuList>
            {productTypeAndProductsPairs.map(([productType, products]) => (
              <PinMenuListItem
                key={`compare-${productType}`}
                aria-label="Compare pinned product type"
                onClick={() => onSelect(products, productType)}
              >
                {formatCompareTitle(productType, products.length)}
              </PinMenuListItem>
            ))}
          </MenuList>
        )}
      />
    </MenuProvider>
  );
}

export default observer(CompareNavButton);
